import { Flex, Icon, Input } from "@chakra-ui/react";
import { RiSearchLine } from "react-icons/ri";
import { search } from 'ss-search';

type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
}
type ClienteData = {
	id: string;
	nome: string;
	doc: string;
	phone: string;
	cid: string;
}
interface DataTableSearchParams {
	clientes: ClienteData[];
	setPesqClientes: (clientes: ClienteData[]) => void;
	controls: ControlsData;
	setControls: (control: ControlsData) => void;
	handleUpdateList: (page: number, perPage: number, clients: ClienteData[]) => void;
}

const DataTableSearch: React.FC<DataTableSearchParams> = ({
	clientes,
	setPesqClientes,
	controls,
	setControls,
	handleUpdateList,
}) => {
	function handlePesquisa(event: string) {
		const texto = event;

		if (texto === '' || texto === ' ') {
			setPesqClientes(clientes);

			setControls({
				...controls,
				page: 1,
				totalPage: Math.ceil(clientes.length / controls.perPage),
			});
			handleUpdateList(1, controls.perPage, clientes);
			return;
		}

		const searchKeys = ['id', 'nome', 'doc', 'cid', 'phone'];
		const results = search(clientes, searchKeys, texto) as ClienteData[];

		setPesqClientes(results);
		setControls({
			...controls,
			page: 1,
			totalPage: Math.ceil(results.length / controls.perPage),
		});

		handleUpdateList(1, controls.perPage, results);
	};

	return (
		<Flex as="form" ml="4">
			<Flex
				as="label"
				flex="1"
				py="2"
				pl="2"
				pr="6"
				maxWidth={400}
				alignSelf="center"
				color="gray.900"
				position="relative"
				bg="gray.50"
				borderRadius="full"
			>
				<Input
					color="gray.900"
					variant="unstyled"
					px="4"
					mr="4"
					placeholder="Pesquisar"
					_placeholder={{ color: 'gray.400' }}
					onChange={e => handlePesquisa(e.target.value)}
				/>

				<Icon as={RiSearchLine} fontSize="20" color="blue.500" />
			</Flex>
		</Flex>
	)
}

export default DataTableSearch;
